import axios from 'axios';

import { CrawledPopupStoreDetail } from './crawls.type';

interface CrawledPopupStoreResponse {
  popupDetail: CrawledPopupStoreDetail;
}

export const CrawlPopgaDetail = async (id: number): Promise<CrawledPopupStoreDetail | null> => {
  try {
    const { data } = await axios.get<CrawledPopupStoreResponse>(`https://crawl.prezemadmin.com/popga-places/${id}`);

    return data.popupDetail
  } catch {
    return null;
  }
}
